/* eslint-disable no-unused-vars */
import Hightlighter from 'react-highlight-words';
import * as S from './ChooseLanguage.styled';
import { Checkbox } from 'components';

export const Content = ({ faundedLangs, search, isActive, toggle }) => {
  return (
    <div style={{ paddingTop: '8px' }}>
      {faundedLangs?.map(({ language_name, language_code }) => (
        <S.Group key={language_code}>
          <S.Row onClick={() => toggle(true, language_code)}>
            <Checkbox
              id={`${language_code}`}
              isChecked={isActive(language_code)}
              name={language_code}
              onChange={toggle}
            />
            <S.GroupName>
              <Hightlighter
                textToHighlight={language_name}
                searchWords={[search]}
                highlightTag='strong'
              />
            </S.GroupName>
          </S.Row>
        </S.Group>
      ))}
    </div>
  );
};
